import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import AtividadesTable from '../Tables/AtividadesTable';

const EMPTY_ATIVIDADES = [];
const EMPTY_ACTIONS = {};

const ActivitiesModal = ({
  show,
  onHide,
  nomePac,
  atividades = EMPTY_ATIVIDADES,
  loadingAtividades = false,
  actions = EMPTY_ACTIONS,
}) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Exames de {nomePac || 'Paciente'}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ minHeight: 500 }}>
        {loadingAtividades ? (
          <div
            className="d-flex justify-content-center align-items-center py-5"
            style={{ minHeight: 400 }}
          >
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <AtividadesTable atividades={atividades} actions={actions} />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default React.memo(ActivitiesModal);
